
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function TestimonialsHeroSection() {
  return (
    <PageHero
      breadcrumb="Testimonials"
      label="Client Success Stories"
      title="Real Results for Real Organisations"
      description="See how we've helped hundreds of South African businesses develop their workforce, achieve SETA compliance, and unlock measurable business growth."
    >
      <Link to="/contact"><button className="btn btn-white">Start Your Journey <i className="ri-arrow-right-line ml-2" /></button></Link>
    </PageHero>
  );
}
